<section>
    <p-confirmDialog  [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">City Search</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> City Search</span>
                        <button *ngIf="sharedService.checkPermission('Admin_Add')" style="height: 30px !important;width: auto!important;
                        margin-top: -2px;border-color: white;" pButton  type="button" icon="pi pi-plus" label="Add"
                            class="p-button-sm p-button-success float-right"  (click)="addCityDetails()"></button>
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
  <section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                  <div class="row">
                      <div class="col-md-4">
                          <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
  
                          <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                          <button [ngClass] = "showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
  
                      </div>
                      <div class="col-md-8">
  
                          <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" *ngIf="sharedService.checkPermission('Admin_Export')" type="button" style="float: right;height: 30px;"
                          (click)="exportCity()"></button>
                          
                           <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                          style="float: right;height: 30px;"></button>
  
                          <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                          [loading]="isSearchLoading" style="float: right;height: 30px;"></button>
                          
  
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12" *ngIf="isCityAdd|| isCityEdit">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">{{title}}</span>
                        </div>
                        <div class="devcare-card-body">
                            <div class="row">
                                <div class="col-md-9">
                                    <form [formGroup] = "cityForm">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="cityName">City Name<span class="required-field">*</span></label>
                                            <input id="cityName" type="text" formControlName="cityName" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="stateName">State Name</label>
                                            <!--<input id="stateName" type="text" formControlName="stateName" pInputText>-->
                                            <p-dropdown   formControlName="stateId" optionValue="stateId" [options]="states" optionLabel="stateName">
                                            </p-dropdown>
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="isActive">Is Active</label>
                                            <br />
                                            <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
                                        </div>
                                    </div>
                                    </form>
                                </div>
                                <div class="col-md-3 d-flex align-items-center">
                                    <button pButton pRipple type="button" label="{{buttonLabel}}" icon="pi pi-check"
                                class="p-button-sm p-button-raised p-button-success m-2" [disabled]="!this.cityForm.valid" (click)="save(cityForm)"></button>
                            <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                class="p-button-sm p-button-raised p-button-danger m-2" (click)="cancel()"></button>

                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <!-- <div class="devcare-table-card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <button pButton type="button" class="p-button-raised p-button-sm m-2" label="Add"
                                    icon="pi pi-plus" (click)="addCityDetails()" *ngIf="(isCityAdd === false) && (isCityEdit === false) && sharedService.checkPermission('Admin_Add')"></button>
                                </div>
                                <div class="col-md-6">
                                   
                                </div>
                            </div>
                        </div> -->
                        <div class="devcare-table-card-header" *ngIf="showToggle">
                            <div class="row">
                                <div class="col-md-6">
            
                                </div>
                                <div class="col-md-6">
                                <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader] = "false" [showClear]="false" (onChange)="showAndHideColumn($event)" style="float: right;">
                                    <ng-template let-column pTemplate="item">
                                        <div class="column-item">
                                            <div>{{column.header}}</div>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                                </div>
                            </div>
                        </div>
                        <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                            <p-table #dt2 [value]="cityList" [lazy]="true" paginatorDropdownAppendTo="body"
                                (onLazyLoad)="loadCityList($event)" dataKey="id" [rows]="10"
                                [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="350px" [resizableColumns]="true" columnResizeMode="expand" 
                                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines"  [responsive]="true"
                                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [globalFilterFields]="['cityName','stateName','isActive','createdBy','createdOn']"  [style]="{'width':'100%'}">
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup [attr.colspan]="selectedColumns.length">
                                        <col *ngIf="isShowColumns('action')">
                                        <col *ngIf="isShowColumns('cityName')">
                                        <col *ngIf="isShowColumns('stateName')">
                                        <col *ngIf="isShowColumns('isActive')">
                                        <col *ngIf="isShowColumns('createdBy')">
                                        <col *ngIf="isShowColumns('createdOn')">
                                        
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pResizableColumn style="width: 5rem" *ngIf="isShowColumns('action')">Action</th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('cityName')">City Name <span
                                                pSortableColumn="cityName" *ngIf="showSorting"><p-sortIcon field="cityName"></p-sortIcon></span>
                                            <app-basic-filter [hidden]="!showFilters" [field]="'cityName'" [filters]="filters" [table]="table"
                                                (applyFilter)="applyFilter()"></app-basic-filter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('stateName')">State Name <span
                                                pSortableColumn="stateName" *ngIf="showSorting"><p-sortIcon field="stateName"></p-sortIcon></span>
                                            <app-basic-filter [hidden]="!showFilters" [field]="'stateName'" [filters]="filters" [table]="table"
                                                (applyFilter)="applyFilter()"></app-basic-filter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('isActive')">Is Active <span
                                                pSortableColumn="isActive" *ngIf="showSorting"><p-sortIcon field="isActive"></p-sortIcon></span>
                                            <app-isactive-filter [hidden]="!showFilters" [field]="'isActive'" [values]="statusValues"
                                                [optionLabel]="'description'" [optionValue]="'id'" [filters]="filters" [table]="table"
                                                (applyFilter)="applyFilter()"></app-isactive-filter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdBy')">Created By <span
                                                pSortableColumn="createdBy" *ngIf="showSorting"><p-sortIcon field="createdBy"></p-sortIcon></span>
                                            <app-basic-filter [hidden]="!showFilters" [field]="'createdBy'" [filters]="filters" [table]="table"
                                                (applyFilter)="applyFilter()"></app-basic-filter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdOn')">Created On <span
                                                pSortableColumn="createdOn" *ngIf="showSorting"><p-sortIcon field="createdOn"></p-sortIcon></span>
                                            <app-date-filter [hidden]="!showFilters" [field]="'createdOn'" [filters]="filters" [table]="table"
                                                (filterDate)="createdOnFilterData($event)" [filterData]="createdOnFilterValue"></app-date-filter>
                                        </th>
                                    </tr>
                                    <tr [hidden]="!showFilters">
                                        <th *ngIf="isShowColumns('action')"></th>
                                        <th *ngIf="isShowColumns('cityName')">{{filters?.cityName[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('stateName')">{{filters?.stateName[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('isActive')">{{getFilterName(statusValues,filters?.isActive[0]?.value)}}</th>
                                        <th *ngIf="isShowColumns('createdBy')">{{filters?.createdBy[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('createdOn')">
                                            <div *ngIf="createdOnFilterValue != undefined">
                                                {{createdOnFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="createdOnFilterValue.length > 1">-</span> {{createdOnFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                            </div>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-cityList>
                                    <tr>
                                        <td style="width: 5rem" *ngIf="isShowColumns('action')"><a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                                    (click)="selectedGridMenuItem = cityList; menu.toggle($event)"></i></a>
                                            <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                                        </td>
                                        <td style="width: 14rem" *ngIf="isShowColumns('cityName')"><span class="table-col-view"><a [routerLink]="" (click)="showCityDetails(cityList.cityId)">{{cityList.cityName}}</a></span></td>
                                        <td style="width: 14rem" *ngIf="isShowColumns('stateName')"><span>{{cityList.stateName}}</span></td>
                                        <td style="width: 14rem" *ngIf="isShowColumns('isActive')"><span class="customer-badge status-active" *ngIf="cityList.isActive">Active</span>
                                            <span class="customer-badge status-inactive" *ngIf="!cityList.isActive">Inactive</span>
                                        </td> 
                                        <td style="width: 14rem" *ngIf="isShowColumns('createdBy')"><span>{{cityList.createdByUser.firstName}}</span></td>
                                        <td style="width: 14rem" *ngIf="isShowColumns('createdOn')"><span>{{cityList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="selectedColumns.length">No City found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
        <div class="col-md-1">

        </div>
    </div>

</section>